
<div class="control-panel">
  <row class="panel-title">
    <column>
      <h4 class="dark">
        Control Panel
      </h4>
    </column>
    <suffix>
      <button class="btn-icon gravel-to-blue collapse-toolbox" @click="panelCollapse()" type="button">
        <span class="sr-only">Collapse/Reveal Toolbox</span>
        <span class="icon arrow-double"></span>
      </button>
    </suffix>
  </row>
  <scroll-area class="panel">
    <control-group v-for="controlGroup in controlGroups" :key="controlGroup.label" :group-name="controlGroup.label" list-style>
      <li v-for="item in controlGroup.items">
        <button
          data-c-tooltip-class="control-panel-tooltip right"
          :data-c-tooltip="item.name"
          :data-type="item.type"
          :aria-label="item.name"
          :class="controlClasses"
          @mousedown.left="drag"
        >
          <icon :class="item.icon"></icon>
          {{ item.name }}
        </button>
      </li>
    </control-group>
  </scroll-area>
</div>
